/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Link} from 'react-router-dom'
import useAuth from '../../../../hooks/useAuth'
import {toAbsoluteUrl} from '../../../helpers'
import {FormattedMessage} from 'react-intl'
import useGlobals from '../../../../hooks/useGlobals'

const HeaderUserMenu: FC = () => {
  const {me, logout} = useAuth()
  const {resetStore} = useGlobals()
  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            <img alt='Logo' src={toAbsoluteUrl('/media/avatars/blank.png')} />
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>
              {me?.firstName} {me?.lastName}
            </div>
            <a href='#' className='fw-bold text-muted text-hover-primary fs-7'>
              {me?.email}
            </a>
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>

      <div className='menu-item px-5'>
        <Link to={'/profile'} className='menu-link px-5'>
          <FormattedMessage id='MENU.MY_PROFILE' />
        </Link>
      </div>

      <div className='menu-item px-5'>
        <a
          onClick={() => {
            logout()
            resetStore();
          }}
          className='menu-link px-5'
        >
          <FormattedMessage id='MENU.SIGN_OUT' />
        </a>
      </div>
    </div>
  )
}

export {HeaderUserMenu}
